$(document).ready(async function () {
  if ($(".index").find(".product-rating")) {
    $(".index").find(".product-rating").css("display", "none");
  }
  if (
    localStorage.getItem("wishlist_goduckee") !== null &&
    localStorage.getItem("wishlist_goduckee") !== ""
  ) {
    var arrayData = localStorage.getItem("wishlist_goduckee").split(",");
    var htmlWishList = await listFetch(arrayData);
    $("#wishlist_index").html(htmlWishList);
    addClass();
  }
});

async function addOrRemoveWishlist(el) {
  if ($(el).hasClass("add_on_wishlist")) {
    $(el).removeClass("add_on_wishlist");
    await removeData($(el).data("handle"));
    addClass();
  } else {
    $(el).addClass("add_on_wishlist");
    saveData($(el).data("handle"));
  }
}

function saveData(data) {
  if (!localStorage.getItem("wishlist_goduckee")) {
    localStorage.setItem("wishlist_goduckee", data);
  } else {
    let array = localStorage.getItem("wishlist_goduckee").split(",");
    if (array.indexOf(data) == -1) {
      localStorage.setItem(
        "wishlist_goduckee",
        localStorage.getItem("wishlist_goduckee") + "," + data
      );
    }
  }
}

async function removeData(el) {
  let array = localStorage.getItem("wishlist_goduckee").split(",");
  let positionData = array.indexOf($(el).data("handle"));
  array.splice(positionData, 1);

  var htmlWishList = await listFetch(array);
  $("#wishlist_index").html(htmlWishList);
  localStorage.setItem("wishlist_goduckee", array.join());
  addClass();
}

async function fetchApi(url) {
  var data = await $.ajax({
    url: "/products/" + url + ".json",
    dataType: "json",
    method: "GET",
    error: (e) => {
      console.log(e);
    },
  });
  return renderHtml(data.product);
}

async function listFetch(data) {
  var html = "";
  for (var i = 0; i < data.length; i++) {
    html = html + (await fetchApi(data[i]));
  }
  return html;
}

function addClass() {
  let array = localStorage.getItem("wishlist_goduckee").split(",");
  let divLength = $(".product-list--collection .thumbnail");
  console.log(divLength.length);
  for (var i = 0; i < array.length; i++) {
    for (let j = 1; j <= divLength.length; j++) {
      if (
        array[i] ===
        $(".product-list--collection .thumbnail:nth-child(" + j + ")").data(
          "handle"
        )
      ) {
        console.log(divLength.length);
        $(".product-list--collection .thumbnail:nth-child(" + j + ")")
          .find(".wishlist_love")
          .addClass("add_on_wishlist");
        break;
      } else {
        continue;
      }
    }
  }
}

function renderHtml(data) {
  return (
    `<div class="
  one-fourth
    column
    thumbnail
    thumbnail-hover-enabled--false
      medium-down--one-half
  " data-handle="` +
    data.handle +
    `" value="` +
    data.handle +
    `"> <div class="product-` +
    data.id +
    `"> <div class="product-wrap "> 
  <div class="relative product_image"> 
  <span class="wishlist_love" data-handle="` +
    data.handle +
    `" onclick="removeData(this)">
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="30"
  height="30"
  viewbox="0 0 24 24"
  style="
    padding: 2px;
    border-radius: 50%;
    background: #fff;
  "
>
  <path d="M12 21.35l-1.45-1.32c-5.15-4.67-8.55-7.75-8.55-11.53 0-3.08 2.42-5.5 5.5-5.5 1.74 0 3.41.81 4.5 2.09 1.09-1.28 2.76-2.09 4.5-2.09 3.08 0 5.5 2.42 5.5 5.5 0 3.78-3.4 6.86-8.55 11.54l-1.45 1.31z"/>
</svg>

</span> <a href="/collections/new-arrivals/products/` +
    data.handle +
    `"> <div class="image__container">
<div class="image-element__wrap" style=" max-width: 1000px;"> <img alt="` +
    data.title +
    `" src="` +
    data.image.src.src +
    `" data-src="` +
    data.image.src +
    `" data-sizes="auto" data-aspectratio="1000/1000" data-srcset="` +
    data.image.src +
    ` 5000w,
    ` +
    data.image.src +
    ` 4500w,
    ` +
    data.image.src +
    ` 4000w,
    ` +
    data.image.src +
    ` 3500w,
    ` +
    data.image.src +
    ` 3000w,
    ` +
    data.image.src +
    ` 2500w,
    ` +
    data.image.src +
    ` 2000w,
    ` +
    data.image.src +
    ` 1800w,
    ` +
    data.image.src +
    ` 1600w,
    ` +
    data.image.src +
    ` 1400w,
    ` +
    data.image.src +
    ` 1200w,
    ` +
    data.image.src +
    ` 1000w,
    ` +
    data.image.src +
    ` 800w,
    ` +
    data.image.src +
    ` 600w,
    ` +
    data.image.src +
    ` 400w,
    ` +
    data.image.src +
    ` 200w" height="1000" width="1000" style=";" class="transition--blur-up lazyautosizes ls-is-cached lazyloaded" srcset="` +
    data.image.src +
    ` 5000w,
    ` +
    data.image.src +
    ` 4500w,
    ` +
    data.image.src +
    ` 4000w,
    ` +
    data.image.src +
    ` 3500w,
    ` +
    data.image.src +
    ` 3000w,
    ` +
    data.image.src +
    ` 2500w,
    ` +
    data.image.src +
    ` 2000w,
    ` +
    data.image.src +
    ` 1800w,
    ` +
    data.image.src +
    ` 1600w,
    ` +
    data.image.src +
    ` 1400w,
    ` +
    data.image.src +
    ` 1200w,
    ` +
    data.image.src +
    ` 1000w,
    ` +
    data.image.src +
    ` 800w,
    ` +
    data.image.src +
    ` 600w,
    ` +
    data.image.src +
    ` 400w,
    ` +
    data.image.src +
    ` 200w" sizes="232px">
</div>
<noscript> <img src="` +
    data.image.src +
    `" alt="` +
    data.title +
    `" class=" noscript">
</noscript></div></a></div></div></div> <a class="product-info__caption " href="/collections/new-arrivals/products/` +
    data.handle +
    `">
<div class="product-details"> <span class="title" itemprop="name">` +
    data.title +
    `</span> <span class="price "> <span class="current_price"> <small class="from"><em>from</em></small> <span class="money">
  $` +
    data.variants[0].price +
    `
</span></span> <span class="was_price"></span> <div class="sold_out"></div></span>
</div></a>
</div>`
  );
}
